var _rect, _path, _path2, _rect2, _circle, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutOfStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27344 10.875C6.27344 9.77043 7.16887 8.875 8.27344 8.875H27.6003C28.7049 8.875 29.6003 9.77043 29.6003 10.875V14.0588H6.27344V10.875Z",
    fill: "url(#paint0_linear_6078_47466)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3389 19.2393H20.5225V15.3516H28.2979V21.1875C24.4772 21.3192 21.4199 24.4568 21.4199 28.3096C21.4199 28.7526 21.4627 29.1858 21.54 29.6064H9.5625C8.45793 29.6064 7.5625 28.711 7.5625 27.6064V15.3516H15.3389V19.2393Z",
    fill: "url(#paint1_linear_6078_47466)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6406,
    y: 15.3594,
    width: 2.59188,
    height: 2.59188,
    fill: "url(#paint2_linear_6078_47466)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7188,
    cy: 28.3672,
    r: 5.45312,
    fill: "url(#paint3_linear_6078_47466)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0391 29.8642L30.4728 26.5625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0391 26.5655L30.4728 29.8672",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6078_47466",
    x1: 17.9369,
    y1: 8.875,
    x2: 17.9369,
    y2: 14.0588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F77B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6078_47466",
    x1: 17.9302,
    y1: 15.3516,
    x2: 17.9302,
    y2: 29.6064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F77B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6078_47466",
    x1: 17.9366,
    y1: 15.3594,
    x2: 17.9366,
    y2: 17.9513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F77B87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6078_47466",
    x1: 28.7188,
    y1: 22.9141,
    x2: 28.7188,
    y2: 33.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F77B87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfStock);
export default __webpack_public_path__ + "static/media/Out_of_stock.64142775f688b50106385da9dfcc11f0.svg";
export { ForwardRef as ReactComponent };